import _objectSpread from "@babel/runtime/helpers/objectSpread";
import { getAdvanced } from '../../utils';
export default (function (node) {
  var html;

  if (node.dataset.decoded) {
    html = node.innerHTML;

    if (process.env.NODE_ENV !== 'production') {
      console.warn('PageBuilder HTML content was unescaped! This may be a Magento configuration error.');
    }
  } else {
    var dom = new DOMParser().parseFromString('<!doctype html><body>' + node.textContent, 'text/html');
    html = dom.body.innerHTML;
  }

  return _objectSpread({
    html: html
  }, getAdvanced(node));
});